import PropTypes from 'prop-types'
import { Form, Field } from 'react-final-form'
import { Button, InputField } from '@mc/design-system'
import { GdprCheckbox } from '@mc/email-capture'
import { usePrimaryCta } from '@mc/growth'
import { useTranslation, Trans } from '@mc/i18n'
import Link from 'components/Link'
import { PricingText } from 'components/PricingText'
import EmailInputError from './EmailInputError'
import { useEmailSignup } from './useEmailSignup'

const EmailSignup = ({ showPricing = true, trackProps }) => {
  const { t } = useTranslation('@mc/next')
  const {
    emailFieldProps,
    loading,
    privacyPath,
    showEmailInputError,
    showPricingText,
    termsPath,
    onSubmit,
    validateForm,
  } = useEmailSignup({ showPricing, trackProps })
  const { ctaCopy } = usePrimaryCta()

  // TODO: Use <EmailCaptureForm />, <EmailCaptureInput /> and <EmailCaptureError /> from @mc/email-capture
  return (
    <Form
      validate={validateForm}
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Field
            component={InputField}
            className='mc-mb-3 mc-text--left'
            {...emailFieldProps}
          />
          {showEmailInputError && (
            <EmailInputError error={t('home.hero.error')} className='mc-mb-2' />
          )}
          <Button type='submit' className='mc-mb-4' fullWidth loading={loading}>
            {ctaCopy}
          </Button>
          <div className='mc-opacity--muted mc-text--left'>
            <GdprCheckbox />
          </div>

          {showPricingText && (
            <p className='mc-mb-4'>
              <PricingText />
            </p>
          )}
          <p className='mc-text-x-small mc-opacity--muted'>
            <Trans i18nKey='home.hero.legal' ns='@mc/next'>
              <Link className='mc-text--link' href={termsPath} passHref />
              <Link className='mc-text--link' href={privacyPath} passHref />
            </Trans>
          </p>
        </form>
      )}
    />
  )
}

EmailSignup.propTypes = {
  showPricing: PropTypes.bool,
  trackProps: PropTypes.object,
}

export default EmailSignup
